module.exports = __webpack_public_path__ + "static/img/13.673a0d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/13.png
// module id = z2/p
// module chunks = 0